import React from 'react';
import { Grid } from '@mui/material';
import FormCollapseCard from '../../../custom-components/forms/processed-fluid-transfer-forms/FormCollapseCard';

function Collapse({ children, label, ...rest }) {
    return (
        <FormCollapseCard label={label}>
            <Grid container rowSpacing={0} columnSpacing={{ xs: 2 }}>
                {children}
            </Grid>
        </FormCollapseCard>
    );
}

export default Collapse;
